// extracted by mini-css-extract-plugin
export var divider = "_1v-0";
export var dividerText = "_1v-1";